// apps/client/src/game/testFinders/shop.ts (M1-T14) — counter and loan desk inside the shop (a free spot in front of each, in reach);
// shopDoor and dropBox outdoors (tile centres). Used by M1-T19's e2e.
import type { TestFinder } from '../testHooks';
import { useGame } from '../../state/store';
import { shopLayout } from '../../world/spaces/shop';
const site = (k: 'shopDoor' | 'dropBox') => () => { const t = useGame.getState().map?.sites[k]; return t ? { id: k, x: t.x + 0.5, y: t.y + 0.5 } : null; };
export const finders: readonly TestFinder[] = [
  { kind: 'counter', find: () => { const l = shopLayout(); return { id: 'counter', x: l.counter.x, y: l.counter.z + 1 }; } },
  { kind: 'loanDesk', find: () => { const l = shopLayout(); return { id: 'loanDesk', x: l.loanDesk.x, y: l.loanDesk.z + 0.8 }; } },
  { kind: 'shopDoor', find: site('shopDoor') },
  { kind: 'dropBox', find: site('dropBox') },
];
